import type { NavigateFunction } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { getOrganizationViewUrl } from '../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../utils/routing/reactRoute'
import { CashPilotNavigatePath } from './types/cashPilotNavigatePath'

export const createCashPilotNavigate = (organizationUrl: string | undefined, navigate: NavigateFunction) => {
  return (path: CashPilotNavigatePath) => {
    if (!organizationUrl) {
      return
    }

    if (path === 'create-invoice') {
      navigate(
        getOrganizationViewUrl(
          organizationUrl,
          reactRoute.organization.invoices.getNewDocumentRoute(
            getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice),
          ),
        ),
      )
      return
    }

    if (path === 'create-bank-account') {
      navigate(getOrganizationViewUrl(organizationUrl, reactRoute.organization.bank.getBankAccountsRoute()))
      return
    }

    if (path === 'cash-flow-analytics') {
      navigate(getOrganizationViewUrl(organizationUrl, reactRoute.organization.cashpilot.getMainRoute()))
      return
    }

    if (path === 'subscription') {
      navigate(`${getOrganizationViewUrl(organizationUrl, 'settings')}#/organization/subscription`)
    }
  }
}
